import React, { useState, useEffect, useRef } from 'react';
import styles from './MultiSelectDropDown.module.css';

const MultiSelectDropdown = ({
  options,
  selectedValues,
  onChange,
  label,
  defaultLabel = 'ALL',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleOption = (value) => {
    let newSelected;

    // Logic: If selecting "ALL", clear others. If selecting specific, clear "ALL".
    if (value === defaultLabel) {
      newSelected = [defaultLabel];
    } else {
      // Remove "ALL" if it exists
      let current = selectedValues.filter((v) => v !== defaultLabel);

      if (current.includes(value)) {
        newSelected = current.filter((v) => v !== value);
      } else {
        newSelected = [...current, value];
      }

      // If nothing left selected, revert to "ALL"
      if (newSelected.length === 0) {
        newSelected = [defaultLabel];
      }
    }
    onChange(newSelected);
  };

  // Generate Display Text
  const getDisplayText = () => {
    if (selectedValues.includes(defaultLabel) || selectedValues.length === 0) {
      return label; // e.g., "All Status"
    }
    if (selectedValues.length === 1) {
      // Find label for value
      const opt = options.find((o) => o.value === selectedValues[0]);
      return opt ? opt.label : selectedValues[0];
    }
    return `${selectedValues.length} Selected`;
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      <div
        className={`${styles.displayBox} ${isOpen ? styles.active : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.text}>{getDisplayText()}</span>
        <span className={styles.arrow}>▼</span>
      </div>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          <div
            className={`${styles.optionItem} ${selectedValues.includes(defaultLabel) ? styles.selected : ''}`}
            onClick={() => toggleOption(defaultLabel)}
          >
            <input
              type="checkbox"
              checked={selectedValues.includes(defaultLabel)}
              readOnly
            />
            <span>{label} (Reset)</span>
          </div>
          <div className={styles.separator} />
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`${styles.optionItem} ${selectedValues.includes(opt.value) ? styles.selected : ''}`}
              onClick={() => toggleOption(opt.value)}
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(opt.value)}
                readOnly
              />
              <span>{opt.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
